import React from 'react';
import './footer.scss';
import { YMaps, Map as YMap, Placemark } from 'react-yandex-maps';
import { useStore } from 'hooks/useStore';

function Map() {
  const position = {
    lat: 52.114793,
    lng: 26.11233
  };
  const zoom = 16;

  return (
    <YMaps>
      <YMap
        className="ymap-container"
        width="100%"
        height="100%"
        defaultState={{ center: [position.lat, position.lng], zoom: zoom }}
      >
        <Placemark
          geometry={[position.lat, position.lng]}
          properties={{ iconCaption: 'Спортивный Диспансер' }}
          options={{ iconColor: '#e74e84', preset: 'islands#icon' }}
        />
      </YMap>
    </YMaps>
  );
}

export function Footer() {
  const {
    state: {
      footer: {
        contacts
      }
    }
  } = useStore();

  return (
    <footer>
      <div className="container margin_60_35">
        <div className="row">
          <div className="col-md-8">
            <Map />
          </div>
          <div className="col-md-4">
            <h6>
              <strong>Адрес:</strong> г. Пинск, ул. Ленина, 45
            </h6>
            <hr />
            {contacts.map(contact => (
              <address key={contact.name}>
                <i className={contact.iconClass} />
                <strong> {contact.name}</strong>
                <p dangerouslySetInnerHTML={{ __html: contact.content }}></p>
              </address>
            ))}
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-md-8">
            <ul id="additional_links">
              <li>
                <a href="#">Разработка сайта: Хлебус Александр</a>
              </li>
            </ul>
          </div>
          <div className="col-md-4">
            <div id="copy">© 2023 Все права защищены</div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
